<p-dialog
  header="{{ formTitle() }}"
  [(visible)]="isVisible"
  showEffect="fade"
  [modal]="true"
  [transitionOptions]="'0ms'"
  [style]="{ width: '50vw' }"
  appendTo="body"
  (onHide)="onDialogHide()"
  [dismissableMask]="true"
>
  <app-progress-spinner [enabled]="loading" />
  @if (!loading) {
    <form #memberCodesForm [formGroup]="manageMemberCodesForm">
      <div class="container">
        <p-pickList
          [source]="sourcePicklist"
          [target]="targetPicklist"
          targetHeader="{{ 'CONTACT.LABEL.ASSIGNED_MEMBER_CODES' | translate }}"
          [dragdrop]="false"
          sourceHeader="{{
            'CONTACT.LABEL.AVAILABLE_MEMBER_CODES' | translate
          }}"
          [responsive]="true"
          [showSourceControls]="false"
          [showTargetControls]="false"
          [sourceStyle]="{
            height: '400px',
            'box-shadow': 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
          }"
          [targetStyle]="{
            height: '400px',
            'box-shadow': 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
          }"
          filterBy="code"
          #picklist
        >
          <ng-template let-memberCode pTemplate="item">
            <div>
              <div>
                <h5>{{ memberCode.code }}</h5>
              </div>
            </div>
          </ng-template>
        </p-pickList>
        <div class="button-wrapper">
          <button
            pButton
            label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
            icon="fa fa-fw fa-save"
            (click)="updateContactListMemberCodes()"
          ></button>
        </div>
      </div>
    </form>
  }
</p-dialog>
